//js import
import '../../scss/pages/merchandise.scss';
import 'swiper/css/bundle';
import Swiper from 'swiper/bundle';
import Modal from 'bootstrap/js/dist/modal';
import { pageHeader } from '../sections/page-header.js';
import {initializeCollaborationsSliders } from '../sections/collaborations.js';

//2. Event listeners
document.addEventListener("DOMContentLoaded", function () { 
    pageHeader();
    Collection()
    productsCatalog();
    initializeCollaborationsSliders();
});

function Collection(){
    let businessSlider = new Swiper('.merchandise-lists__slider', {
        speed:1000,
        spaceBetween: 16,
        slidesPerView: 1,
        centeredSlides: true,
        loop: true,
        freeMode: true,
        navigation: {
            prevEl: ".merchandise-lists__prev",
            nextEl: ".merchandise-lists__next",
        },
        pagination: {
            el: ".merchandise-lists__pagination",
            clickable:true
        },
        breakpoints: {
            320: {
                centeredSlides: false,
                slidesPerView: 2
            },
            768:{
                slidesPerView: 3,
                spaceBetween: 20,
                centeredSlides: false,
            },
            992:{
                slidesPerView: 3,
                spaceBetween: 20,
                centeredSlides: false,
            },
            1024:{
                slidesPerView: 3,
                spaceBetween: 20,
                centeredSlides: false,
            },
            1440:{
                slidesPerView: 3,
                spaceBetween: 20,
                centeredSlides: false,
            },
            1600:{
                slidesPerView: 3,
                spaceBetween: 20,
                centeredSlides: false,
            },
            1920:{
                slidesPerView: 4,
                spaceBetween: 20,
                centeredSlides: false,
            }
        }
    });
}

function productsCatalog(){
    const ModalMarketPlace = new Modal('#marketPlaceModal', {
        keyboard: false
    })
    let tokopediaURL= catalogData.tokopediaLogo_url
    let shopeeURL= catalogData.shopeeLogo_url
    let cardProducts=document.querySelectorAll('.card-product');
    let cardMarketPlaceContainer=document.querySelector('#cardMarketPlaceContainer')
    cardProducts.forEach(n => n.addEventListener('click', function (event) {
        event.preventDefault()
        let dataTokopedia=n.dataset.tokopedia
        let dataShopee=n.dataset.shopee
        let cardMarketPlaceMarkup='';
        if(dataTokopedia!=''){
            cardMarketPlaceMarkup +=` <a class="card-marketplace" href="${dataTokopedia}">
            <img class="card-marketplace__image" src="${tokopediaURL}">
        </a>`
        }
        if(dataShopee !=''){
            cardMarketPlaceMarkup +=` <a class="card-marketplace"  href="${dataShopee}">
            <img class="card-marketplace__image" src="${shopeeURL}">
        </a>`
        }
        ModalMarketPlace.show()
        cardMarketPlaceContainer.innerHTML=cardMarketPlaceMarkup;
    }))
}


